import React from 'react';
import { Row, Col } from 'reactstrap';
import { Button, Input } from 'reactstrap';

class Search extends React.Component { 
    constructor(props) {
        super(props)

        this.state = {
            search: ''
        }
    }

    handleChange = e => {
        this.setState({ search: e.target.value })
    }

    handleKeypress = e => {
        if (e.key === 'Enter') {
            this.props.search(this.state.search)
        }
    }

    handleSearch = e => {
        console.log('handle', this.state)
        this.props.search(this.state.search)
    }

    render() {
        return (
            <Row>
                <Col xs="8">
                    <Input onChange={this.handleChange} onKeyPress={this.handleKeypress} type="search" name="search" id="search" placeholder="search..." />
                </Col>
                <Col xs="4">
                    <Button onClick={this.handleSearch}><i className="fas fa-search wide d-none d-sm-inline">&nbsp;</i> Search</Button>
                </Col>
            </Row>
        )
    }
}

export default Search
